export default {"src":"/sitetest/_next/static/media/first_nav_active02.7f638ff5.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};